// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Milky Way - Main Export
 * 
 * Aggregates all configuration for the Milky Way universe.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { MilkyWayAliensPlanets } from './AliensConfig';

export const universeMilkyway = {
  id: 'milkyway',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: MilkyWayAliensPlanets,
};

export default universeMilkyway;
